/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { format, parseISO } from 'date-fns'
import {
  Image, StyledText, ProgressBar, MyListButton,
} from '..'
import { API_IMAGE_OBJECT } from '../../utils/types'
import styles from './styles'
import {
  PlayIcon,
  EpisodePlayIcon,
  EllipseIcon,
  LiveIcon,
  LivePlayIcon,
  PadlockIcon,
} from '../icons'
import { colors } from '../../styles'
import { transparentize } from '../../utils/colors'
import { readCookies, parseRemainingTimeString } from '../../utils/stopResume'
import SvodExclusiveWarning from '../AdLabels/SvodExclusiveWarning'
import convertTimeToDecimal from '../../utils/convertTimeToDecimal'
import convertTimeto24hr from '../../utils/convertTimeTo24hr'
import { trackEvent } from '../../utils/dtmHelpers'
import getSportsSubtitle from '../../utils/strings'

const getSizes = (large, specialEvent) => {
  if (large) {
    return '(min-width: 1024px) 33vw,(min-width: 1400px) 25vw, 50vw'
  }
  if (specialEvent) {
    return '100vw'
  }
  return '(min-width: 768px) 33vw,(min-width: 1024px) 25vw,(min-width: 1400px) 20vw, 50vw'
}

// TODO: remove old card designs and rename this

const CardRefresh = ({
  id,
  el,
  image,
  posterImage,
  continueWatching,
  label,
  large,
  link,
  progress,
  remainingdur,
  overlay,
  playIcon,
  subtitle,
  title,
  guid,
  newWindow,
  addClasses,
  noScale,
  sponsorship,
  svodExclusive,
  specialEvent,
  recoID,
  rank,
  showTitle,
  live,
  index,
  groupId,
  description,
  poster,
  logo,
  hasHoverOverlay,
  genre,
  page,
  progmImages,
  mobile,
  programmeHead,
  duration,
  programmeTab,
  liveTab,
  headerName,
  summary,
  availableUntil,
  recommendedTab,
  numEpisodes,
  programmeName,
  isLive,
  sportsExclusive,
}) => {
  const [progressBar, setProgressBar] = useState(progress)
  const [cwDuration, setCwDuration] = useState(remainingdur)
  const [hoverOverlay, setHoverOverlay] = useState(hasHoverOverlay)
  const [liveSubtitle, setLiveSubtitle] = useState(subtitle)

  const isNews = link && link.includes('news.stv.tv')
  useEffect(() => {
    const cwEps = readCookies()
    let filtered = {}
    filtered = cwEps.find(data => (data.id.toString()) === id)
    if (filtered) {
      const remprogress = filtered.pos / filtered.dur
      const remduration = `${parseRemainingTimeString(filtered.dur - filtered.pos)} left`
      setProgressBar(remprogress)
      setCwDuration(remduration)
    }
    // TODO: Refactor this to use an imported list of guids
    if (['p-promo-card', 'stv-player-vip'].includes(id)) {
      setHoverOverlay(false)
    }

    if (live) {
      setProgressBar(getLiveProgress(subtitle))
    }
  }, [])

  const analyticsTracking = () => {
    if (page === 'home') {
      // @Todo once added region from cms to api response, should be replaced with it
      // eslint-disable-next-line no-nested-ternary
      const region = sportsExclusive ? 'Premier Sports' : (window?.digitalData.user.broadcastRegion === 'stv-region' ? 'STV' : 'UK')
      trackEvent('homepageClick', {
        'stv.homepage.row': headerName,
        'stv.homepage.rownumber': groupId,
        'stv.homepage.column': index,
        'stv.card.title': title,
        homepage_marker: region,
      })
    } else if (isLive) {
      trackEvent('row_click', { item: `Episodes/More Like This - Live,99,${title}` })
    } else {
      trackEvent('row_click', { item: title })
    }
  }

  const getLiveProgress = (timeRange) => {
    if (!timeRange) return 0
    const [startTime, endTime] = timeRange?.split(' - ')
    const timeNow = new Date().toString().split(' ')[4].slice(0, -3)
    const timeInDecimal = convertTimeToDecimal(timeNow)
    const startEndNowTimes = [startTime, endTime].map(time => convertTimeto24hr(time))
    setLiveSubtitle(`${startEndNowTimes[0]} - ${startEndNowTimes[1]}`)
    const startEndNowFloats = startEndNowTimes.map(time => convertTimeToDecimal(time))
    const currentShowDuration = startEndNowFloats[1] - startEndNowFloats[0]
    const playHeadNow = timeInDecimal - startEndNowFloats[0]
    return playHeadNow / currentShowDuration
  }

  const getTitleText = (epTitle) => {
    const text = epTitle?.replace(/[^\w\s].*/, '')
    return text
  }
  const Element = el
  const episode = playIcon && overlay !== 'Trailer'
  const classes = ['CardRefresh', (large ? 'large' : ''), (live ? 'live' : ''), (programmeHead ? 'programHead' : ''), ((programmeTab || liveTab) ? 'tabCard' : ''), (recommendedTab ? 'recom-card' : ''), (noScale ? 'no-scale' : ''), (episode ? 'episode' : ''), (poster ? 'poster' : ''), (specialEvent ? 'specialEvent' : ''), (continueWatching ? 'continue-watching' : ''), (page === 'categories' ? 'categories' : ''), (sportsExclusive ? 'sports' : ''), ...addClasses]
    .filter(Boolean)
    .join(' ')
  const overlayClasses = ['HoverOverlay', (large ? 'large' : ''), (episode ? 'episode' : 'programme'), (poster ? 'poster' : ''), (title.length > 37 ? 'truncate-desc' : ''), (sportsExclusive ? 'sports' : '')]
    .filter(Boolean)
    .join(' ')
  const position = live ? index + 1 : rank
  const [isMobile, setIsMobile] = useState(false)

  const users = useSelector(stateSelector => stateSelector.user)
  const psEnabled = useSelector(state => state?.featureFlags?.psEnabled)

  const sportsEntitlementError = psEnabled && sportsExclusive && (!users.currentlySubscribed || (users.currentlySubscribed && users.subscriptionType !== 'premier_sports'))
  const myListimages = poster ? posterImage : image
  const titleText = title.includes('Episode') ? getTitleText(title) : title

  useEffect(() => {
    if (window?.innerWidth <= 768) {
      setIsMobile(true)
    } else if (window?.innerWidth <= 835 && window?.innerHeight <= 1300) {
      setIsMobile(true)
    } else if (window?.innerWidth <= 1300 && window?.innerHeight <= 835) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  })

  let linkStrip

  if (isNews) {
    linkStrip = link
  } else {
    // Strip https://player.stv.tv from link
    linkStrip = link?.replace('https://player.stvqa.tv', '')
    linkStrip = linkStrip?.replace('https://player.stv.tv', '')
    // Strip slash off end of linkStrip
    linkStrip = linkStrip?.replace(/\/$/, '')
  }

  return (
    <Element
      className={classes}
      data-recommended-id={recoID}
      data-recommended-position={recommendedTab ? id : position}
      data-recommended-title={recommendedTab ? programmeName : title}
      title={recommendedTab ? programmeName : title}
    >
      <figure style={{ zIndex: 3 }}>
        {live && (
          <div className="live-gradient">
            {progressBar > 0 && (
              <div className={`progress-bar live`}>
                <ProgressBar progress={progressBar} color={colors.liveRed} bgColor={'rgba(246, 246, 246, 0.20)'} />
              </div>
            )}
          </div>
        )}
        {((!episode && !live) || programmeTab || liveTab) && sportsEntitlementError && users.gettingDetails && (
          <div className={`ps-overlay ${poster ? 'poster' : 'programme'}`}>
            <PadlockIcon color="#FFFF00" width={16} height={19} />
            <p className="programme-detail">{getSportsSubtitle(title)}</p>
          </div>
        )}
        {episode && sportsEntitlementError && users.gettingDetails && !programmeTab && (
          <span style={{ display: 'flex', justifyContent: 'flex-end', padding: '1em' }}>
            <PadlockIcon color="#FFFF00" width={16} height={19} />
          </span>
        )}
        <a
          href={linkStrip}
          onClick={analyticsTracking}
          title={recommendedTab ? programmeName : title}
          target={newWindow ? 'stv' : null}
          rel={newWindow ? 'noopener noreferrer' : null}
          aria-label={newWindow ? `${title} (opens in a new window)` : null}
        >
          {!programmeHead && (
            <Image
              image={image}
              sponsorship={sponsorship}
              sizes={getSizes(large, specialEvent)}
              priority={specialEvent}
            />
          )}
          {programmeHead && (
            <Image
              image={progmImages}
              sponsorship={sponsorship}
              sizes={getSizes(large, specialEvent)}
              priority={specialEvent}
            />
          )}
          {(programmeTab || liveTab) && (
            <div className="figure-overlay-program" style={isMobile ? { opacity: 1 } : {}}>
              <EpisodePlayIcon
                withBorder
                width="24px"
                height="24px"
                backgroundColor={transparentize(colors.black, 0.5)}
                borderWidth="1px"
              />

            </div>

          )}
          {recommendedTab && (
            <div className="figure-overlay-program recom" style={isMobile ? { opacity: 1, background: `linear-gradient(179.62deg, rgba(21, 21, 21, 0) 62%, rgba(21, 21, 21, 0.9) 91%)` } : {}}>
              <div className="recom-prog">
                {genre}
                {numEpisodes > 0 && (
                  <div className="numEpisode">
                    <EllipseIcon center />
                    {`${numEpisodes} episode${numEpisodes !== 1 ? 's' : ''}`}
                  </div>
                )}
                <h3 style={{ display: 'none' }}>{programmeName}</h3>
              </div>
            </div>
          )}
          {((programmeTab || liveTab) || continueWatching)
         && (
           <div className={`figure-overlay-cw ${continueWatching && 'cont-watch'}`}>
             {cwDuration && (
               <div className={`duration ${continueWatching && 'cont-watch'}`}>{cwDuration}</div>
             )}
             {progressBar > 0 && (
               <div className="progress-gradient">
                 <div className={`progress-bar ${cwDuration && 'cont-watch'}`}>
                   <ProgressBar progress={progressBar} color={colors.primaryText} bgColor={'rgba(246, 246, 246, 0.20)'} />
                 </div>
               </div>
             )}

           </div>
         )}
        </a>
        {((playIcon && (!programmeTab && !liveTab) && !continueWatching)) && (
          <div className={`figure-overlay${continueWatching ? ' continue-watching' : ''}`}>
            <PlayIcon
              withBorder
              width="24px"
              height="24px"
              backgroundColor={transparentize(colors.black, 0.5)}
              borderWidth="1px"
            />
          </div>
        )}
        {(live || continueWatching) && (
          <div className="figure-overlay live">
            <LivePlayIcon
              withBorder
              width="48px"
              height="48px"
            />
          </div>
        )}

        { svodExclusive && (
          <div className="svod-exclusive-label">
            <SvodExclusiveWarning />
          </div>
        )}

        {/* the purple overlays for non live content */}
        {overlay && !live && (
          <figcaption>
            <StyledText
              el="p"
              className="cardSubtitle"
              style={{ color: colors.primaryText }}
            >
              {overlay}
            </StyledText>
          </figcaption>
        )}

        {/* the red live overlays */}
        {psEnabled && live && (
          <React.Fragment>
            <figcaption className="live">
              <LiveIcon />
              <p
                className="live-subtitle"
                style={{ color: colors.primaryText }}
              >
                LIVE
              </p>
            </figcaption>
            {sportsEntitlementError && users.gettingDetails
            && (
              <div className="ps-overlay">
                <PadlockIcon color="#FFFF00" width={16} height={19} />
              </div>
            )}
            <div className="ps-logo-overlay">
              {Object.keys(logo).length !== 0 && (
                <div className="ps-logo">
                  <Image
                    image={logo}
                    alt="ps logo"
                    width={50}
                    height={50}
                  />
                </div>
              )}
            </div>
          </React.Fragment>
        )}
        {overlay && live && (
          <figcaption className="live">
            <LiveIcon />
            <p
              className="live-subtitle"
              style={{ color: colors.primaryText }}
            >
              {overlay === 'STV' ? 'LIVE' : overlay}
            </p>
          </figcaption>
        )}

        {live && (
          <div className="live-info">
            <p className="live-title">{title}</p>
            <p className="live-time">{liveSubtitle}</p>
          </div>
        )}

        {hoverOverlay && (page === 'home' || page === 'categories') && (
          <div className={overlayClasses}>
            <div className="content">
              <div id="infoWrapper">

                <h3 className="title" aria-label={`${episode ? 'episode' : 'programme'} title`}>
                  {title}
                </h3>
                <h4 className="subtitle" aria-label={`${episode ? 'episode' : 'programme'} subtitle`}>
                  {episode ? genre || subtitle : genre}
                </h4>
                <div className="description-container" aria-label={`${episode ? 'episode' : 'programme'} description`}>
                  <div className="description-inner-container">
                    <p className="description">
                      {description}
                    </p>
                  </div>
                  {episode && (
                    <div className="playButton" aria-label="play button">
                      <PlayIcon
                        withBorder
                        width="24px"
                        height="24px"
                        backgroundColor={transparentize(colors.black, 0.5)}
                        borderWidth="1px"
                      />
                    </div>
                  )}
                </div>
              </div>
              {!episode && (
                <MyListButton
                  programme={{
                    name: title,
                    image: myListimages,
                    programmeGuid: id,
                  }}
                />
              )}
            </div>
            {/* TODO = change to psudo element if not used for resizing */}
            <div className="border" />
          </div>
        )}
      </figure>
      {(programmeTab || liveTab) && (
        <div className="cardText">
          <a
            href={linkStrip}
            onClick={analyticsTracking}
            title={title}
            target={newWindow ? 'stv' : null}
            rel={newWindow ? 'noopener noreferrer' : null}
            aria-label={newWindow ? `${title} (opens in a new window)` : null}
          >
            <div className="cardWrap">
              {title && (
                <div className="cardTitle">
                  {titleText}
                </div>
              )}
              {title && (
                <div className="iconWrap"><EllipseIcon /></div>
              )}
              {duration && (<div className="cardDuration"> {duration}</div>)}
            </div>
            {summary && (
              <div className="cardSummary">
                {summary}
              </div>
            )}
            {availableUntil && (
              <div className="cardAvailable"> Available until
                <p className="dateSummary">{format(parseISO(availableUntil), 'd MMM yyyy')}</p>
              </div>
            )}
          </a>
        </div>
      )}
      {(!programmeTab && !liveTab) && (
        <div className="card-text">
          {title && (
            <StyledText
              el="h3"
              className={!showTitle ? 'cardTitleHidden' : 'cardTitle1'}
            >
              {linkStrip && (
                <a
                  href={linkStrip}
                  onClick={analyticsTracking}
                  title={title}
                  target={newWindow ? 'stv' : null}
                  rel={newWindow ? 'noopener noreferrer' : null}
                  aria-label={newWindow ? `${title} (opens in a new window)` : null}
                >
                  {
                    title
                  }
                </a>
              )}
              {!link && title}
            </StyledText>
          )}

          {label && !specialEvent && !live && (
            <StyledText className={!continueWatching ? 'cardLabel' : 'continueWatchingCardLabel'}>
              {label}
            </StyledText>
          )}

          {subtitle && !isNews && (
            <StyledText
              className={!showTitle ? 'cardTitleHidden' : 'cardSubtitle'}
            >
              {subtitle}
            </StyledText>
          )}
        </div>
      )}
      <style jsx>{styles}</style>
    </Element>

  )
}

CardRefresh.propTypes = {
  el: PropTypes.string,
  image: API_IMAGE_OBJECT,
  progmImages: API_IMAGE_OBJECT,
  posterImage: API_IMAGE_OBJECT,
  logo: PropTypes.object,
  continueWatching: PropTypes.bool,
  label: PropTypes.string,
  large: PropTypes.bool,
  link: PropTypes.string,
  overlay: PropTypes.string,
  playIcon: PropTypes.bool,
  progress: PropTypes.number,
  remainingdur: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  newWindow: PropTypes.bool,
  addClasses: PropTypes.arrayOf(PropTypes.string),
  noScale: PropTypes.bool,
  programmeDetails: PropTypes.shape({
    title: PropTypes.string,
    images: API_IMAGE_OBJECT,
    guid: PropTypes.string,
  }),
  sponsorship: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    image: PropTypes.shape({
      id: PropTypes.number,
      _filepath: PropTypes.string,
    }),
  }),
  groupId: PropTypes.number,
  headerName: PropTypes.string,
  svodExclusive: PropTypes.bool,
  specialEvent: PropTypes.bool,
  recoID: PropTypes.string,
  rank: PropTypes.number,
  showTitle: PropTypes.bool,
  live: PropTypes.bool,
  index: PropTypes.number,
  description: PropTypes.string,
  genre: PropTypes.string,
  poster: PropTypes.bool,
  hasHoverOverlay: PropTypes.bool,
  page: PropTypes.string,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  programmeHead: PropTypes.bool,
  mobile: PropTypes.bool,
  duration: PropTypes.string,
  programmeTab: PropTypes.bool,
  liveTab: PropTypes.bool,
  summary: PropTypes.string,
  availableUntil: PropTypes.string,
  recommendedTab: PropTypes.bool,
  numEpisodes: PropTypes.number,
  programmeName: PropTypes.string,
  guid: PropTypes.string,
  isLive: PropTypes.bool,
  sportsExclusive: PropTypes.bool,
}

CardRefresh.defaultProps = {
  id: '',
  el: 'li',
  image: {},
  progmImages: {},
  programmeDetails: {},
  posterImage: {},
  logo: {},
  continueWatching: false,
  label: '',
  large: false,
  overlay: '',
  title: '',
  playIcon: false,
  progress: 0,
  remainingdur: '',
  subtitle: '',
  newWindow: false,
  addClasses: [],
  noScale: false,
  link: null,
  sponsorship: null,
  svodExclusive: false,
  specialEvent: false,
  recoID: null,
  rank: null,
  showTitle: true,
  live: false,
  index: null,
  description: null,
  genre: '',
  poster: false,
  hasHoverOverlay: false,
  page: null,
  programmeHead: false,
  mobile: false,
  groupId: 0,
  headerName: '',
  duration: '',
  programmeTab: false,
  liveTab: false,
  summary: '',
  availableUntil: '',
  recommendedTab: false,
  numEpisodes: 0,
  programmeName: '',
  guid: '',
  isLive: false,
  sportsExclusive: false,
}

export default CardRefresh
